module.exports = "/React/dist/aa25ec2ba0d2f7e4fff7c978e0762cfe.png";